module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Medium.ttf
// module id = 679
// module chunks = 0